import { getData  , postFiles , putData , putFiles , deleteData } from './index';

import { sortByUpdateDate } from '../utils/utils';

import {
  GET_FILES,
  POST_FILE,
  PUT_FILE,
  ERROR_FILES,
  DELETE_FILE
} from "./types"

const MEDIAS_CACHE_TTL_MS = 5 * 60 * 1000;
const mediasCacheByCompany = {};

export function invalidateMediasCache(companyId) {
  if (companyId) {
    delete mediasCacheByCompany[companyId];
    return;
  }
  Object.keys(mediasCacheByCompany).forEach((key) => {
    delete mediasCacheByCompany[key];
  });
}

export function mediasTabToApiType(tabValue) {
  switch (tabValue) {
    case 'vidéos':
      return 'videos';
    case 'fichiers':
      return 'files';
    case 'miniatures':
      return 'thumbnails';
    case 'images':
    default:
      return 'images';
  }
}

export function mediaTypeToApiType(mediaType) {
  switch (mediaType) {
    case 'video':
      return 'videos';
    case 'file':
      return 'files';
    case 'school':
      return 'school';
    case 'press':
      return 'press';
    case 'commercial':
      return 'commercial';
    case 'pressRelease':
      return 'pressRelease';
    case 'image':
    default:
      return 'images';
  }
}

export async function getResourceFilesAction(dispatch, type) {
  const query = buildFileQueryString({
    type,
    scope: 'all',
    limit: 100,
  });
  const url = `/file?${query}`;
  let files = [];

  await getData(ERROR_FILES, url, dispatch, true).then((response) => {
    files = response.files || [];
  });

  return sortByUpdateDate(files);
}

function buildFileQueryString(params) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      searchParams.set(key, value);
    }
  });
  return searchParams.toString();
}

export async function getMediasAction(dispatch, companyId, { force = false } = {}) {
  if (!companyId) {
    return;
  }

  const cached = mediasCacheByCompany[companyId];
  const now = Date.now();

  if (!force && cached && (now - cached.fetchedAt < MEDIAS_CACHE_TTL_MS)) {
    dispatch({
      type: GET_FILES,
      payload: cached.files
    });
    return;
  }

  const query = buildFileQueryString({ company: companyId });
  const url = `/file?${query}`;
  let files = [];

  await getData(ERROR_FILES, url, dispatch, true).then((response) => {
    files = response.files || [];
  });

  const sorted = sortByUpdateDate(files);
  mediasCacheByCompany[companyId] = {
    files: sorted,
    fetchedAt: now
  };

  dispatch({
    type: GET_FILES,
    payload: sorted
  });
}

export function mergeMediasIntoStore(dispatch, currentList, newFiles) {
  if (!newFiles?.length) {
    return;
  }

  const incoming = Array.isArray(newFiles) ? newFiles : [newFiles];
  const merged = currentList ? [...currentList] : [];

  incoming.forEach((file) => {
    if (file?._id && !merged.find((item) => item._id === file._id)) {
      merged.push(file);
    }
  });

  dispatch({
    type: GET_FILES,
    payload: merged
  });
}

export async function getMediasPageAction(dispatch, {
  companyId,
  type = 'images',
  search = '',
  page = 1,
  limit = 24
}) {
  const query = buildFileQueryString({
    company: companyId,
    type,
    search: search.trim(),
    page,
    limit
  });

  const url = `/file?${query}`;
  let result = { files: [], total: 0, page: 1, limit };

  await getData(ERROR_FILES, url, dispatch, true).then((response) => {
    result = {
      files: response.files || [],
      total: response.total || 0,
      page: response.page || page,
      limit: response.limit || limit
    };
  });

  return result;
}


export async function putMediaAction( dispatch , id, data , isFormData = false ) {
  
  const url = `/file/${id}`;
  var putFile;

  if (isFormData) {
    await putFiles(PUT_FILE, ERROR_FILES ,  url, dispatch, data , true ).then((response)=>{
      putFile = response.file
    });
  } else {
    await putData(PUT_FILE, ERROR_FILES ,  url, dispatch, data , true ).then((response)=>{
      putFile = response.file
    });
  }

  if (putFile?.company) {
    invalidateMediasCache(String(putFile.company));
  }
  
  dispatch({
    type : PUT_FILE,
    payload : putFile
  });

};

export async function postMediaAction( dispatch , data ) {
  
  const url = "/file";
  var addFile;

  await postFiles(POST_FILE, ERROR_FILES , url, dispatch, data , true ).then((response)=>{
    addFile = response.files
  });

  const companyId = typeof data?.get === 'function' ? data.get('company') : data?.company;
  if (companyId) {
    invalidateMediasCache(companyId);
  } else if (addFile?.[0]?.company) {
    invalidateMediasCache(String(addFile[0].company));
  }

  dispatch({
    type : POST_FILE,
    payload : addFile
  });

};

export async function deleteMedia(dispatch , id, companyId) {
  const url = "/file/" + id;
  var deleteFile;

  await deleteData(ERROR_FILES, url, dispatch, true ).then((response)=>{
    deleteFile = response
  });

  if(deleteFile) {
    if (companyId) {
      invalidateMediasCache(String(companyId));
    }
    dispatch({
      type : DELETE_FILE,
      payload : id
    });
  }
}
